import Helmet from "react-helmet";
import React from "react";
import favicon from "../../../assets/images/favicon.ico";

const BaseHelmet = (props) => {
  return (
    <Helmet>
      <meta charSet="UTF-8" content="width=device-width, user-scalable=0, minimal-ui" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta
        name="description"
        content="F1-informer widget. All information about past races. Graphs, statistics and visualizations of events."
      />

      <link rel="apple-touch-icon" sizes="57x57" href={favicon} />
      <link rel="apple-touch-icon" sizes="60x60" href={favicon} />
      <link rel="apple-touch-icon" sizes="72x72" href={favicon} />
      <link rel="apple-touch-icon" sizes="76x76" href={favicon} />
      <link rel="apple-touch-icon" sizes="114x114" href={favicon} />
      <link rel="apple-touch-icon" sizes="120x120" href={favicon} />
      <link rel="apple-touch-icon" sizes="144x144" href={favicon} />
      <link rel="apple-touch-icon" sizes="152x152" href={favicon} />
      <link rel="apple-touch-icon" sizes="180x180" href={favicon} />
      <link rel="icon" type="image/png" sizes="192x192" href={favicon} />
      <link rel="icon" type="image/png" sizes="32x32" href={favicon} />
      <link rel="icon" type="image/png" sizes="96x96" href={favicon} />
      <link rel="icon" type="image/png" sizes="16x16" href={favicon} />
      <link rel="icon" href={favicon} />
      <link rel="apple-touch-icon" href={favicon} />
      {props.font !== undefined && (
        <link href={`https://fonts.googleapis.com/css?family=${props.font}`} rel="stylesheet" />
      )}

      <title>{props.title}</title>
      <meta name="description" content="Helmet application" />
    </Helmet>
  );
};

export default BaseHelmet;
